// 默认的请求超时时间
export const DEFAULT_REQUEST_TIMEOUT = 20 * 1000;

// 请求环境
export const DEFAULT_REQUEST_ENV = 'production';

// 请求 query 对象
export const DEFAULT_REQUEST_QUERY = {};

// 请求 body data 对象
export const DEFAULT_REQUEST_DATA = {};

// 是否需要鉴定登录态
export const DEFAULT_NEED_AUTH = true;

// 是否处理 query 参数为下划线
export const QUERY_UNDERLIZE = true;

// 在前端请求错误是： 比如参数错误
export const DEFAULT_FAIL_RESPONSE: BaseResponse<any> = {
  errors: null,
  msg: 'Request Query Error: 前端错误',
  code: -50000,
  data: {},
};

// 当跨域被浏览器拦截时
export const DEFAULT_CLIENT_FAIL_RESPONSE: BaseResponse<any> = {
  errors: null,
  msg: '请求没有发出，可能被浏览器拦截',
  code: -40000,
  data: {},
};

export const getDefaultError = (code: number): BaseResponse<any> => {
  let msg = '发生错误了，请稍后重试';
  if (code === 429) {
    msg = '请求太多次数， 请稍后再试试';
  }
  return {
    errors: null,
    msg,
    code,
    data: {},
  };
};

// 解析 json 错误时
export const DEFAULT_ERROR_RESPONSE: BaseResponse<any> = {
  msg: '解析后端返回数据错误： JSON.parse error',
  code: 500,
  data: {},
  errors: null,
};

// 返回成功的基础数据结构
export const DEFAULT_SUCCESS_RESPONSE: BaseResponse<any> = {
  errors: null,
  msg: 'ok',
  code: 0,
  data: {},
};
